import SkeletonButton from './variations/SkeletonButton';
import SkeletonButtonIcon from './variations/SkeletonButtonIcon';
import SkeletonHeading from './variations/SkeletonHeading';
import SkeletonInput from './variations/SkeletonInput';
import SkeletonParagraph from './variations/SkeletonParagraph';
import SkeletonSized from './variations/SkeletonSized';

export * from './Skeleton';

export {
	SkeletonHeading,
	SkeletonButtonIcon,
	SkeletonButton,
	SkeletonParagraph,
	SkeletonInput,
	SkeletonSized,
};
